import React from "react";
import {
  Button,
  Grid,
  Typography,
  Stack
} from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Modal from "../../Components/Modal";
import { estruturaMercadologica } from "../../Requests";
import useGlobalContext from "../../Hooks/useGlobalContext";
import { useSnackbar } from "notistack";

interface IRemoveEstruturaMercadologicaProps {
  idEstruturaMercadologica: number;
  reloadResourceTable: () => void;
  close: () => void;
}

const RemoveEstruturaMercadologica: React.FC<IRemoveEstruturaMercadologicaProps> = ({
  idEstruturaMercadologica,
  reloadResourceTable,
  close
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoading, loading } = useGlobalContext();

  const handleCloseModal = () => close();

  const handleRemove = async () => {
    if (!idEstruturaMercadologica) return;

    setLoading?.(true);

    const {
      data = "",
      status = 500,
      message = "Erro ao remover estrutura."
    } = await estruturaMercadologica.delete(`${idEstruturaMercadologica}`);

    setLoading?.(false);

    const variant = status === 200 || status === 204 ? "success" : "error";
    enqueueSnackbar(message, { variant });

    reloadResourceTable();
    close();
  };

  return (
    <Modal
      title="Remover importação de Estrutura Mercadológica"
      open={!loading}
      closeModal={handleCloseModal}
      maxWidth="sm"
    >
      <Grid container spacing={0.5}>
        <Grid item xs={12}>
          <Typography variant="body1">
            Tem certeza de que deseja remover esta importação da Estrutura Mercadológica?
          </Typography>
          <Typography variant="body2" fontWeight="bold" color="error" mt={2}>
            Esta ação é irreversível!
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Button variant="outlined" onClick={handleCloseModal} aria-label="Cancelar remoção">
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="error"
              startIcon={<DeleteForeverIcon />}
              onClick={handleRemove}
              aria-label="Confirmar remoção"
            >
              Remover
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default RemoveEstruturaMercadologica;
